import CompetitionModal from './CompetitionModal';

export default CompetitionModal;

